

import { ELanguageActions, LanguageActions } from "@edp-store/actions/language.actions";
import { ILanguageState, initialLanguageState } from "@edp-store/state/language.state";

export function languageReducers(
    state = initialLanguageState,
    action: LanguageActions
): ILanguageState {
    switch (action.type) {
        case ELanguageActions.SetLanguages: {
            return {
                ...state,
                languages: action.languages
            };
        }
        default: {
            return state;
        }
    }
}
